import type {Content} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import {LogoBarDefault} from './DefaultVariation'
import {LogoBarLarge} from './LargeVariation'

/**
 * Props for `LogoBar`.
 */
export type LogoBarProps = SliceComponentProps<Content.LogoBarSlice>

/**
 * Component for "LogoBar" Slices.
 */
const LogoBar = ({slice}: LogoBarProps) => {
  switch (slice.variation) {
    case 'large':
      return <LogoBarLarge slice={slice} />
    case 'default':
      return <LogoBarDefault slice={slice} />
    default:
      return null
  }
}

export default LogoBar
